import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FreelancerInvoiceService from '../../../Services/FreelancerInvoiceService';
import FreelancerInvoiceItem from '../../../Domain/FreelancerInvoiceItem';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import UploadInvoiceImageWindow from './UploadInvoiceImageWindow';
import ApproveInvoiceImageWindow from './ApproveInvoiceImageWindow';
import ViewInvoiceImageWindow from './ViewInvoiceImageWindow';
import FreelancerInvoiceStatusEnum from '../../../Enums/FreelancerInvoiceStatusEnum';
import LoadingIcon from '../../../Elements/LoadingIcon';
import { saveAs } from 'file-saver';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import DataTableStyleEnum from '../../../Enums/DataTableStyleEnum';
import FreelancerInvoicesSearchParams from './FreelancerInvoicesSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import UserService from '../../../Services/userService';
import AuthService from '../../../Services/authService';

class FreelancerInvoiceAdmin extends React.Component {
  static defaultProps = {};

  range = 20;

  constructor(props) {
    super(props);

    const tempSearchItem = new FreelancerInvoicesSearchParams();
    if (props.freelancerInvoiceId) {
      tempSearchItem.FreelancerInvoiceId = props.freelancerInvoiceId.toString();
    }
    if (props.freelancerUserId) {
      tempSearchItem.FreelancerUserIdOrName = props.freelancerUserId.toString();
    }
    if (props.freelancerPaymentExportId) {
      tempSearchItem.FreelancerPaymentExportId = props.freelancerPaymentExportId.toString();
    }

    this.state = {
      searchItem: tempSearchItem,
      selected: -1,
      secondaryLoading: false,
      itemList: [],
      selectedItem: null,
      pageNumber: 1,
      numberOfElementsInTheTable: 0,
      shownWindow: ShownOverWindowsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
    };

    this.startSearch = this.startSearch.bind(this);
    this.clickOnFinalizeButton = this.clickOnFinalizeButton.bind(this);
    this.clickOnSetToPaidButton = this.clickOnSetToPaidButton.bind(this);
    FreelancerInvoiceItem.clickOnUploadInvoiceImageIcon = this.clickOnUploadInvoiceImageIcon.bind(this);
    FreelancerInvoiceItem.clickOnApproveInvoiceImageIcon = this.clickOnApproveInvoiceImageIcon.bind(this);
    FreelancerInvoiceItem.clickOnDownloadInXLSIcon = this.clickOnDownloadInXLSIcon.bind(this);
    FreelancerInvoiceItem.clickOnInvoiceImage = this.clickOnInvoiceImage.bind(this);
    FreelancerInvoiceItem.clickOnDeleteIcon = this.clickOnDeleteIcon.bind(this);
    this.clickOnExportPaymentButton = this.clickOnExportPaymentButton.bind(this);
    this.clickOnSetToManuallyPaidButton = this.clickOnSetToManuallyPaidButton.bind(this);
    this.clickOnExportToExcelButton = this.clickOnExportToExcelButton.bind(this);
    this.clickOnExportToExcelButtonInPopup = this.clickOnExportToExcelButtonInPopup.bind(this);
    this.clickOnSendToTheVendorButton = this.clickOnSendToTheVendorButton.bind(this);
    this.clickOnSendToTheVendorForFinalizationButtonInPopup =
      this.clickOnSendToTheVendorForFinalizationButtonInPopup.bind(this);
    this.clickOnSendToVendorForFinalizationButton = this.clickOnSendToVendorForFinalizationButton.bind(this);
    this.clickOnExportAttachmentsButton = this.clickOnExportAttachmentsButton.bind(this);
    this.clickOnExportAttachmentsButtonInPopup = this.clickOnExportAttachmentsButtonInPopup.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  clickOnDeleteIcon(item) {
    ErrorMessage.SetApprove(`This invoice (id: ${item.FreelancerInvoiceId}) will be deleted.`, () =>
      this.clickOnDeleteButtonInPopup(item)
    );
  }

  clickOnDeleteButtonInPopup(item) {
    FreelancerInvoiceService.DeleteInvoiceById(item.FreelancerInvoiceId)
      .then(() => {
        this.refresh();
        ErrorMessage.SetSuccess(`The invoice (id: ${item.FreelancerInvoiceId}) has been deleted successfully.`);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('FIA167');
      });
  }

  clickOnInvoiceImage(item) {
    this.setState({
      shownWindow: ShownOverWindowsEnum.View,
    });
  }

  clickOnUploadInvoiceImageIcon(item) {
    this.setState({
      selectedItem: item,
      shownWindow: ShownOverWindowsEnum.Upload,
    });
  }

  clickOnApproveInvoiceImageIcon(item) {
    this.setState({
      selectedItem: item,
      shownWindow: ShownOverWindowsEnum.Approve,
    });
  }

  clickOnDownloadInXLSIcon(item) {
    this.setState({ secondaryLoading: true });
    FreelancerInvoiceService.DownloadInvoiceListDetailsInExcel(item.FreelancerInvoiceId)
      .then((result) => {
        this.setState({ secondaryLoading: false });

        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let fileName = `VendorInvoice_${item.FreelancerUserOfficeName}_${item.FreelancerUserName}_${
          item.FreelancerInvoiceId
        }_${dateTimeHelper.timestamp()}.xlsx`;
        fileName = fileName.replaceAll('BARE ', '');
        fileName = fileName.replaceAll(' ', '_');

        saveAs(
          new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          fileName
        );
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FIA238');
        this.setState({ secondaryLoading: false });
      });
  }

  clickOnFinalizeButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.Created)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });

    const message = this.state.allItemsInTheSearchSetAreSelected
      ? 'You will finalize all of the invoices in the actual search (just the ones in Created status). Are you sure?'
      : `You will finalize the invoices with the following IDs: ${ids}`;

    ErrorMessage.SetApprove(message, this.clickOnFinalizeButtonInPopup.bind(this));
  }

  clickOnSetToPaidButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.InvoiceApproved)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? 'You will set the Approved invoices in the actual search set to Paid.'
      : `You will set the following invoices to Paid. IDs: ${ids}`;
    ErrorMessage.SetApprove(message, this.clickOnSetToPaidButtonInPopup.bind(this));
  }

  clickOnSetToManuallyPaidButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.DeletedAtTipalti)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected ? (
      "You will set the 'Deleted At Tipalti' invoices in the actual search set to 'Manually Paid Outside Of Tipalti'. Do you want to continue?"
    ) : (
      <div>
        <p>You will set the following invoices to 'Manually Paid Outside Of Tipalti': </p>
        <p>IDs: {ids} </p>
        <p>Do you want to continue?</p>
      </div>
    );
    ErrorMessage.SetApprove(message, this.clickOnSetToManuallyPaidButtonInPopup.bind(this));
  }

  clickOnExportToExcelButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `You will export all invoices (${this.state.numberOfElementsInTheTable}) in the actual search set to Excel.`
      : `You will export the following invoices to Excel. IDs: ${ids}`;
    ErrorMessage.SetApprove(message, this.clickOnExportToExcelButtonInPopup.bind(this));
  }

  clickOnSendToTheVendorButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `All invoices (${this.state.numberOfElementsInTheTable}) in the actual search set will be sent to its vendor in email in xlsx format. Do you want to continue?`
      : `The following invoice summaries will be sent as a link to the vendor. The link will be valid for 72 hours. IDs: ${ids}. Do you want to continue?`;
    ErrorMessage.SetApprove(message, this.clickOnSendToTheVendorButtonInPopup.bind(this));
  }

  clickOnSendToVendorForFinalizationButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `All invoices (${this.state.numberOfElementsInTheTable}) in the actual search set will be sent to its vendor. Invoices in Created status can be finalized by the vendor, and an invoice image can be uploaded. The link will be valid for 72 hours.`
      : `The following invoices will be sent to the vendor. Invoices in Created status can be finalized by the vendor, and an invoice image can be uploaded. The link will be valid for 72 hours. IDs: ${ids} `;
    ErrorMessage.SetApprove(message, this.clickOnSendToTheVendorForFinalizationButtonInPopup.bind(this));
  }

  clickOnExportAttachmentsButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `You will export all invoices' attachments (${this.state.numberOfElementsInTheTable}) in the actual search set into a ZIP.`
      : `You will export the following invoices' attachments into a ZIP. IDs: ${ids}`;
    ErrorMessage.SetApprove(message, this.clickOnExportAttachmentsButtonInPopup);
  }

  clickOnExportPaymentButton() {
    let ids = '';
    this.state.itemList
      .filter((i) => i.Selected)
      .forEach((f) => {
        if (ids !== '') ids += ', ';
        ids += f.FreelancerInvoiceId;
      });
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? 'You will export all Approved invoices in the actual search set.'
      : `You will export the following invoices. IDs: ${ids} `;
    ErrorMessage.SetApprove(message, this.clickOnExportPaymentButtonInPopup.bind(this));
  }

  clickOnFinalizeButtonInPopup() {
    const selectedIds = this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.Created)
      .map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.FinalizeSelectedFreelancerInvoices(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    )
      .then((result) => {
        if (parseInt(result.errorNumber) > 0) {
          const popupText =
            parseInt(result.errorNumber) > 1
              ? `There were ${result.errorNumber} invoices which couldn't be finalized because of missing line items or negative total amount. The line items have been attached. Please, check the 'Created' invoices, and finalize them again.`
              : "There was an invoice which couldn't be finalized because of missing line items or negative total amount. The line items have been attached. Please, check the 'Created' invoice, and finalize it again.";
          ErrorMessage.SetWarning(popupText);
        } else {
          ErrorMessage.SetSuccess('The selected created invoices have been finalized.');
        }
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FIA255');
      });
  }

  clickOnSetToPaidButtonInPopup() {
    const selectedIds = this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.InvoiceApproved)
      .map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.SetToPaidSelectedFreelancerInvoices(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    )
      .then((result) => {
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FIA448');
      });
  }

  clickOnSetToManuallyPaidButtonInPopup() {
    const selectedIds = this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.DeletedAtTipalti)
      .map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.SetToManuallyPaidSelectedFreelancerInvoices(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    )
      .then((result) => {
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FIA508');
      });
  }

  clickOnExportToExcelButtonInPopup() {
    const selectedIds = this.state.itemList.filter((i) => i.Selected).map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.ExportSelectedFreelancerInvoicesToExcel(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    ).catch((error) => {});

    window.setTimeout(() => {
      this.setState({ secondaryLoading: false });
      ErrorMessage.SetSuccess(
        'File creation has started and your export will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
      );
    }, 100);
  }

  clickOnExportAttachmentsButtonInPopup() {
    const selectedIds = this.state.itemList.filter((i) => i.Selected).map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.ExportSelectedFreelancerInvoiceAttachmentsToZip(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    ).catch(() => ErrorMessage.SetErrorMessage('FIA345'));

    window.setTimeout(() => {
      this.setState({ secondaryLoading: false });
      ErrorMessage.SetSuccess(
        'File creation has started and your export will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
      );
    }, 100);
  }

  clickOnSendToTheVendorButtonInPopup() {
    const selectedIds = this.state.itemList.filter((i) => i.Selected).map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.SendSelectedFreelancerInvoicesToTheVendor(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    );
    window.setTimeout(() => {
      this.setState({ secondaryLoading: false });
      ErrorMessage.SetSuccess('Distribution has started. You will receive a confirmation once it is complete.');
    }, 2000);
  }

  clickOnSendToTheVendorForFinalizationButtonInPopup() {
    const selectedIds = this.state.itemList.filter((i) => i.Selected).map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.SendSelectedFreelancerInvoicesToTheVendorForFinalization(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    ).catch(() => ErrorMessage.SetErrorMessage('FIA705'));
    window.setTimeout(() => {
      this.setState({ secondaryLoading: false });
      ErrorMessage.SetSuccess(
        'Distribution has started. You will receive a confirmation in your personal message repository once it is complete'
      );
    }, 1000);
  }

  clickOnExportPaymentButtonInPopup() {
    const selectedIds = this.state.itemList
      .filter((i) => i.Selected && i.Status === FreelancerInvoiceStatusEnum.InvoiceApproved)
      .map((f) => f.FreelancerInvoiceId);
    FreelancerInvoiceService.ExportSelectedFreelancerInvoicesAsPayment(
      this.state.allItemsInTheSearchSetAreSelected,
      selectedIds,
      this.state.searchItem
    )
      .then((result) => {
        this.refresh();
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetNotification(
          `The selected invoices (#${result.numberOfExportedInvoices}) have been exported. You will find the export on the Vendor Payment Exports page.`
        );
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('FIA535');
      });
  }

  IsThereAnySelectedWithStat(stat) {
    if (this.state.allItemsInTheSearchSetAreSelected) return this.state.searchItem.Status === stat;
    return this.state.itemList.some((i) => i.Status === stat && i.Selected === true);
  }

  IsThereAnySelectedWithoutStat() {
    return this.state.itemList.find((i) => i.Selected === true) !== undefined;
  }

  IsExportPaymentApplicable() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return (
        this.state.searchItem.OfficeId !== '' &&
        this.state.searchItem.Status === FreelancerInvoiceStatusEnum.InvoiceApproved
      );
    }
    if (
      this.state.itemList.find(
        (i) => i.Status === FreelancerInvoiceStatusEnum.InvoiceApproved && i.Selected === true
      ) === undefined
    )
      return false;
    const selectedItems = this.state.itemList.filter(
      (i) => i.Status === FreelancerInvoiceStatusEnum.InvoiceApproved && i.Selected === true
    );
    const officeIds = new Set(selectedItems.map((i) => i.FreelancerUserOfficeName));
    return officeIds.size === 1;
  }

  IsThereAnySelectable() {
    return (
      this.state.itemList.filter(
        (x) =>
          x.Status === FreelancerInvoiceStatusEnum.Created ||
          x.Status === FreelancerInvoiceStatusEnum.InvoiceApproved ||
          x.Status === FreelancerInvoiceStatusEnum.DeletedAtTipalti
      ).length > 0
    );
  }

  renderActionButtonRow() {
    if (this.state.itemList.length === 0) return null;

    return (
      <FigmaButtonRow
        buttons={[
          {
            iconName: 'fa-solid fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnFinalizeButton,
            tooltip: 'Finalize',
            disabled: !this.IsThereAnySelectedWithStat('Created'),
          },
          {
            iconName: 'fa-solid fa-file-export',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnExportPaymentButton,
            tooltip: 'Link to Export Payment',
            disabled: !this.IsThereAnySelectedWithStat('InvoiceApproved'),
          },
          {
            iconName: 'fa-solid fa-file-invoice-dollar',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnSetToPaidButton,
            tooltip: 'Set to Paid',
            //Finalized, Approved, Exported, DeletedAtTipalti
            disabled: !(
              this.IsThereAnySelectedWithStat('Finalized') ||
              this.IsThereAnySelectedWithStat('InvoiceApproved') ||
              this.IsThereAnySelectedWithStat('Exported') ||
              this.IsThereAnySelectedWithStat('DeletedAtTipalti')
            ),
          },
          {
            iconName: 'fa-solid fa-envelope-circle-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnSendToVendorForFinalizationButton,
            tooltip: 'Send to Vendor',
            //Created, Finalized, InvoiceDissmissed
            disabled: !(
              this.IsThereAnySelectedWithStat('Created') ||
              this.IsThereAnySelectedWithStat('Finalized') ||
              this.IsThereAnySelectedWithStat('InvoiceDissmissed')
            ),
          },
          {
            iconName: 'fa-solid fa-file-excel',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnExportToExcelButton,
            tooltip: 'Create Excel Summary',
            disabled: !this.IsThereAnySelectedWithoutStat(),
          },
          {
            iconName: 'fa-solid fa-file-arrow-down',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnExportAttachmentsButton,
            tooltip: 'Export Attachments',
            disabled: !this.IsThereAnySelectedWithoutStat(),
            roleKey: 'freelancerinvoice_exportattachments',
          },
        ]}
      />
    );
  }

  renderWindows() {
    switch (this.state.shownWindow) {
      case ShownOverWindowsEnum.Upload:
        return (
          <UploadInvoiceImageWindow
            freelancerInvoiceId={this.state.selectedItem.FreelancerInvoiceId}
            clickOnCancel={(refresh) => {
              this.setState({ shownWindow: ShownOverWindowsEnum.None });
              if (refresh) this.refresh();
            }}
          />
        );
      case ShownOverWindowsEnum.Approve:
        return (
          <ApproveInvoiceImageWindow
            freelancerInvoiceId={this.state.selectedItem.FreelancerInvoiceId}
            data={this.state.selectedItem}
            clickOnCancel={(refresh) => {
              this.setState({ shownWindow: ShownOverWindowsEnum.None });
              if (refresh) this.refresh();
            }}
          />
        );
      case ShownOverWindowsEnum.View:
        return (
          <ViewInvoiceImageWindow
            freelancerInvoiceId={this.state.selected}
            clickOnCancel={() => {
              this.setState({ shownWindow: ShownOverWindowsEnum.None });
            }}
          />
        );

      default:
        return null;
    }
  }

  startSearch(searchItem) {
    if (
      AuthService.HasRoleArray(['FinanceAdmin_VendorMgtm', 'VendorInvoicingAdmin_*']) &&
      !AuthService.IsAdmin() &&
      !searchItem?.OfficeId
    ) {
      searchItem = { ...searchItem, OfficeId: UserService.GetOfficeIdOfLoggedInUser() };
    }
    this.setState({
      searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <LoadingIcon loading={this.state.secondaryLoading} />
        {this.renderActionButtonRow()}
        <TabOfDataTable
          type={FreelancerInvoiceItem}
          serviceFunction={FreelancerInvoiceService.GetInvoiceList}
          convertDBItemsFunction={FreelancerInvoiceService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={FreelancerInvoicesSearchParams}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          style={DataTableStyleEnum.Simple}
          popupEnabled={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          itemTypeName={'invoices'}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in invoice id, vendor id, export id, yrmo, status, vendor name or type...'
          errorCode='FIA477'
        />
        {this.renderWindows()}
      </div>
    );
  }
}

export default FreelancerInvoiceAdmin;
